module.exports = "<div class=\"gallery-lightbox__btn gallery-lightbox__btn--<%=label%> js-gallery-<%=label%>\">\n<button data-link-name=\"gallery-lightbox <%=label%>\" class=\"gallery-lightbox__btn-body\"><i></i><%=label%></button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/src/javascripts/projects/common/views/content/button.html
// module id = 719
// module chunks = 2